<template>
  <div class="app-page">
    <div v-if="isHomePage" class="bg-block" />
    <AppHeader :isHomepage="isHomePage" />
    <router-view />
    <AppFooter />
    <SVGicon />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

import AppFooter from './components/AppFooter.vue'
import AppHeader from './components/AppHeader.vue'
import SVGicon from './components/SVGicon.vue'

const route = useRoute()
const isHomePage = computed(() => route.path === '/')
</script>
